import { Card, Modal } from 'antd';
import AdminSidebar from '../Components/Sidebar';
import TableComponent from '../Components/TableComponent';
import { getCheckrLogs } from '../redux/slices/settingsSlice';
import { useState } from 'react';
import JsonView from '@uiw/react-json-view';
import { basicTheme } from '@uiw/react-json-view/basic';

function CheckrLogs() {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedRecord, setSelectedRecord] = useState(null);

    const columns = [
        {
            title: 'User Name',
            dataIndex: 'user_name',
            key: 'user_name',
            render: (_, record) => {
                return `${record?.user?.first_name ?? ""} ${record?.user?.last_name ?? ""}`
            }
        },
        {
            title: 'Type',
            dataIndex: 'type',
            key: 'type',
        },
        {
            title: 'Message',
            dataIndex: 'message',
            key: 'message',
            render: (_, record) => {
                return record?.status == 400 ? record?.message?.error : null
            },
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            render: (_, record) => JSON.parse(record?.response)?.data?.object?.status ? JSON.parse(record?.response)?.data?.object?.status : record?.user?.status
        },
        // {
        //     title: 'Action',
        //     dataIndex: 'key',
        //     key: 'key',
        //     render: (_, record) => <a onClick={() => viewData(record)}>View</a>,
        // },
    ];

    const viewData = async (record) => {
        setSelectedRecord(null)
        setSelectedRecord(record);
        setIsModalOpen(true);
    }

    return (
        <>
            <AdminSidebar renderContent={
                <Card
                    title="Checkr Logs"
                    style={{ marginBottom: 24 }}
                >
                    <TableComponent
                        listData={getCheckrLogs}
                        columns={columns}
                        placeholder="Search Logs..."
                    />
                </Card>
            } />

            <Modal
                title="Checkr Log Details"
                open={isModalOpen}
                onCancel={() => setIsModalOpen(false)}
                footer={null}
            >
                {selectedRecord && (
                    <div>
                        {selectedRecord?.user && (
                            <p>
                                <strong>User:</strong>{" "}
                                {selectedRecord?.user?.first_name}{" "}
                                {selectedRecord?.user?.last_name}
                            </p>
                        )}
                        <div>
                            <JsonView value={JSON.parse(selectedRecord?.response)} style={basicTheme} />
                        </div>
                    </div>
                )}
            </Modal>
        </>
    );
}

export default CheckrLogs;